const routes = {
  home: {
    path: "/",
    name: "Home",
  },
  suppliers: {
    path: "/suppliers",
    name: "Suppliers",
  },
  about: {
    path: "/about",
    name: "About",
  },
  contact: {
    path: "/contact",
    name: "Contact",
  },
  privacy: {
    path: "/privacy",
    name: "Privacy Policy",
  },
  404: {
    path: "/404",
    name: "Page Not Found",
  },
};

export default routes;
